import { buildQueryString, get, request } from "core-web/libs/GrebbCommerceAPI/util";

import { API_URL } from "core-web/constants";
import { startsWithLocalePrefix } from "core-web/utils/checkForLocalePrefix";

export default async (applicationId, path, parameters = {}, url, locale, applicationPath, origin) => {
    // Build parameters.
    const builtParameters = buildQueryString(parameters);
    let slug = path;

    const hasLocalePrefix = startsWithLocalePrefix(slug);

    if (!hasLocalePrefix) {
        slug = locale === "sv_SE" && applicationPath === "/sv" ? "/sv" : "/en";
        slug += path;
    }

    if (slug.length > 1 && slug.endsWith("/")) {
        slug = slug.slice(0, -1).toLowerCase();
    }

    const requestUrl = `/frontend/content/resolve-slug?application_id=${applicationId}&slug=${encodeURIComponent(
        slug,
    )}${builtParameters && `&${builtParameters}`}`;

    let response;
    if (!API_URL && url) {
        response = await request({ method: "GET", path: requestUrl, baseUrl: url });
        if (response) {
            return await response.body();
        }
    }

    response = await get(requestUrl);

    return await response.body();
};
